var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 25,
  viewBox: "0 0 322 328",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M59 225.5C59 168.891 104.891 123 161.5 123a102.496 102.496 0 0 1 72.478 30.022A102.496 102.496 0 0 1 264 225.5c0 56.609-45.891 102.5-102.5 102.5S59 282.109 59 225.5Zm41 0c0 33.966 27.534 61.5 61.5 61.5a61.497 61.497 0 0 0 61.5-61.5c0-33.966-27.534-61.5-61.5-61.5S100 191.534 100 225.5Z",
  fill: "#0E7"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M260.631 46.844c-3.238 8.973-11.74 14.952-21.265 14.956H81.215a20.567 20.567 0 0 1-19.27-13.41L43.907 0H0l23.404 62.789c9.068 24.125 32.075 40.128 57.81 40.211h158.152c26.736-.045 50.62-16.752 59.868-41.88L322 0h-43.805l-17.564 46.844Z",
  fill: "#0E7"
})));
export { SvgLogoIcon as ReactComponent };
export default __webpack_public_path__ + "c1f0f07edddb6146f98be3dd57ff947f.svg";